import startImg from '@/assets/images/caret-right-fill.svg';
import pauseImg from '@/assets/images/pause-fill.svg';
import { pauseImageTimer, resumeImageTimer } from '@/helpers/mediaUtils';
import { pauseAllProgressBars, resumeAllProgressBars } from '@/modules/actions/headerLineDuration.js';
import { loadPcMediaWindow } from '@/helpers/pcMediaLoadWindow';

const isQuestionnairePlaybackLocked = () => (
  window.__storeeelQuestionnairePlaybackLocked === true
  || Boolean(document.querySelector('[data-storeeel-questionnaire-modal="true"]'))
);

const pauseVideoSafely = (video) => {
  if (!(video instanceof HTMLVideoElement)) return;
  try {
    video.pause();
  } catch { void 0; }
};

const safePlay = (video) => {
  if (!(video instanceof HTMLVideoElement)) return;
  if (isQuestionnairePlaybackLocked()) {
    pauseVideoSafely(video);
    return;
  }
  // pauseと競合した際にAbortErrorになるため、再生失敗は握りつぶす
  try {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => { void 0; });
    }
  } catch { void 0; }
};

export const mobileVideoControls = () => {
  const parentElement = document.querySelector('.storeeel-menu-area-icons');

  if (!parentElement) return;

  let imageTime = 0;

  parentElement.addEventListener('click', (event) => {
    if (!event.target) return;

    const activeImage = document.querySelector(
      '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper img.storeeel-media-image'
    );
    const activeImageStyle = activeImage ? window.getComputedStyle(activeImage) : null;
    const isImageVisible = Boolean(
      activeImage
      && activeImageStyle
      && activeImageStyle.display !== 'none'
      && activeImageStyle.visibility !== 'hidden'
    );

    const activeVideo = document.querySelector(
      '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video.storeeel-movie'
    );

    // =====================
    // 一時停止
    // =====================
    if (event.target.id === 'pause-desktop') {
      imageTime = pauseImageTimer(); // ← 画像でも動画でも止める

      if (activeVideo instanceof HTMLVideoElement) {
        activeVideo.pause();
      }

      pauseAllProgressBars();

      event.target.src = startImg;
      event.target.alt = 'start';
      event.target.id = 'start-desktop';
    }

    // =====================
    // 再開
    // =====================
    else if (event.target.id === 'start-desktop') {
      if (isImageVisible && imageTime > 0) {
        // 停止前に設定されていた自動送り処理をそのまま再開する
        resumeImageTimer(undefined, imageTime);
      } else if (activeVideo instanceof HTMLVideoElement) {
        safePlay(activeVideo);
      }

      resumeAllProgressBars();

      event.target.src = pauseImg;
      event.target.alt = 'pause';
      event.target.id = 'pause-desktop';
    }
  });
};

export const controlIcon = () => {
  const controlIcon = document.querySelector('.storeeel-video-control');
  if (controlIcon && controlIcon.id === 'start-desktop') {
    controlIcon.src = pauseImg;
    controlIcon.alt = 'pause';
    controlIcon.id = 'pause-desktop';
  }
};

// activeのスライドの動画のみ再生する関数
export const activeVideoPlay = () => {
  const isPc = !window.storeeelItems?.isMobile;
  const activeVideo = document.querySelector(
    '.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video.storeeel-movie'
  );
  const allVideos = document.querySelectorAll(
    '.storeeel-swiper-group-wrapper .swiper-slide .slide-media-wrapper video'
  );

  if (isQuestionnairePlaybackLocked()) {
    allVideos.forEach((video) => pauseVideoSafely(video));
    return;
  }

  if (isPc) {
    // PCでコンテンツ遷移後に再生が再開される場合は、操作ボタン表示も再生中に合わせる
    controlIcon();
  }

  if (isPc) {
    // PCでは非アクティブ動画のautoplayを常に無効化し、遅延読み込み後の自動再生を防ぐ
    allVideos.forEach((video) => {
      if (!(video instanceof HTMLVideoElement)) return;
      if (video !== activeVideo) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
      }
    });
  }

  // スライドの動画を一時停止
  const pauseSelectors = [
    '.storeeel-swiper-group-wrapper .swiper-slide-prev .slide-media-wrapper video.storeeel-movie',
    '.storeeel-swiper-group-wrapper .swiper-slide-next .slide-media-wrapper video.storeeel-movie'
  ];
  pauseSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(video => {
      if (video instanceof HTMLVideoElement) {
        video.pause();
        video.currentTime = 0;
      }
    });
  });

  if (isPc) {
    // 中央のスライドを最優先に読み込み、決めた順番で隣を先読みする（src は createSlide で保留済み）
    loadPcMediaWindow(activeVideo?.closest('.swiper-slide')
      || document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active'));
  }

  // activeのスライドの動画を再生
  safePlay(activeVideo);
};
